export default __webpack_public_path__ + "static/media/mk-group-logo.637a2beb.png";